import React, { useEffect, useState } from "react";
import tiktokVerification from "./assets/files/tiktokIlcSDQkREl9rjxBS0GR6Ay0Bwntkvxui.txt";

const TermsScreen = () => {
  const [verificationContent, setVerificationContent] = useState("");

  useEffect(() => {
    const loadVerificationFile = async () => {
      try {
        const response = await fetch(tiktokVerification);
        const content = await response.text();
        setVerificationContent(content);
      } catch (error) {
        console.error("Lỗi khi đọc file:", error);
      }
    };

    loadVerificationFile();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h1 className="text-3xl font-bold text-center text-blue-600 mb-8">
            ĐIỀU KHOẢN DỊCH VỤ - AIContent
          </h1>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Giới thiệu và Chấp nhận Điều khoản
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Chào mừng bạn đến với AIContent! Các Điều khoản Dịch vụ này ("Điều
              khoản") là một thỏa thuận pháp lý ràng buộc giữa bạn ("Người
              dùng", "bạn") và AIContent ("Công ty", "chúng tôi"), quy định các
              quyền và nghĩa vụ của bạn khi sử dụng dịch vụ quản lý và tự động
              hóa nội dung fanpage Facebook của chúng tôi ("Dịch vụ").
            </p>
            <p className="text-gray-600 leading-relaxed mt-4">
              Bằng cách truy cập hoặc sử dụng Dịch vụ, bạn xác nhận rằng bạn đã
              đọc, hiểu và đồng ý bị ràng buộc bởi các Điều khoản này. Nếu bạn
              không đồng ý với bất kỳ phần nào của Điều khoản, bạn không được
              phép sử dụng Dịch vụ.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. Mô tả Dịch vụ
            </h2>
            <p className="text-gray-600 mb-4">
              AIContent là một công cụ dựa trên nền tảng web và ứng dụng trí tuệ
              nhân tạo (AI) cho phép người dùng tự động hóa việc tạo và đăng nội
              dung lên fanpage Facebook của họ. Các tính năng chính của Dịch vụ
              bao gồm, nhưng không giới hạn ở:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-4">
              <li>
                Tự động tạo nội dung (văn bản, hình ảnh) dựa trên các chủ đề và
                cài đặt do người dùng cung cấp
              </li>
              <li>Lên lịch đăng bài tự động lên fanpage</li>
              <li>Phân tích hiệu suất nội dung và cung cấp các báo cáo</li>
              <li>Quản lý nhiều fanpage (tùy thuộc vào gói dịch vụ)</li>
            </ul>
            <p className="text-gray-600 font-medium">
              Lưu ý quan trọng: AIContent hoạt động thông qua API của Facebook
              và tuân thủ các chính sách của Facebook. Tuy nhiên, AIContent
              không phải là sản phẩm của Facebook và không được Facebook bảo
              trợ, chứng thực hoặc liên kết.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. Tài khoản Người dùng
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Đăng ký:</strong> Để sử dụng Dịch vụ, bạn có thể cần
                phải tạo một tài khoản AIContent. Bạn phải cung cấp thông tin
                chính xác, đầy đủ và cập nhật khi đăng ký.
              </p>
              <p>
                <strong>Tính chính xác của thông tin:</strong> Bạn cam kết rằng
                tất cả thông tin bạn cung cấp cho AIContent là chính xác, đầy đủ
                và không gây hiểu lầm.
              </p>
              <p>
                <strong>Bảo mật tài khoản:</strong> Bạn có trách nhiệm bảo mật
                thông tin đăng nhập tài khoản của mình. Bạn phải thông báo ngay
                cho AIContent nếu phát hiện truy cập trái phép.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Quyền Thu thập và Sử dụng Dữ liệu
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Sử dụng miễn phí và đồng ý dữ liệu:</strong> AIContent
                cung cấp Dịch vụ miễn phí cho người dùng. Bằng việc sử dụng
                Dịch vụ miễn phí này, bạn đồng ý rằng AIContent có quyền thu
                thập và sử dụng dữ liệu của bạn.
              </p>
              <p>
                <strong>Phạm vi dữ liệu:</strong> Dữ liệu được thu thập bao gồm
                nhưng không giới hạn ở: nội dung bài viết được tạo, thông tin
                fanpage, lịch sử sử dụng dịch vụ, và các thông tin kỹ thuật khác
                liên quan đến việc sử dụng Dịch vụ.
              </p>
              <p>
                <strong>Mục đích sử dụng:</strong> Dữ liệu của bạn có thể được
                AIContent sử dụng để cải thiện chất lượng dịch vụ, phát triển
                tính năng mới, nghiên cứu và phát triển công nghệ AI, và các
                mục đích hợp pháp khác.
              </p>
              <p>
                <strong>Cam kết bảo mật:</strong> AIContent cam kết bảo vệ dữ
                liệu của bạn theo Chính sách Quyền riêng tư của chúng tôi.
                Chúng tôi sẽ không bán hoặc chia sẻ dữ liệu cá nhân của bạn
                cho bên thứ ba mà không có sự đồng ý của bạn, trừ khi được
                yêu cầu bởi pháp luật.
              </p>
              <p>
                <strong>Quyền của người dùng:</strong> Bạn có quyền yêu cầu
                truy cập, chỉnh sửa hoặc xóa dữ liệu cá nhân của mình bất kỳ
                lúc nào bằng cách liên hệ với chúng tôi. Chi tiết về quyền
                của bạn được mô tả trong Chính sách Quyền riêng tư.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              5. Mô hình Dịch vụ Miễn phí
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Dịch vụ miễn phí:</strong> AIContent hiện cung cấp
                Dịch vụ hoàn toàn miễn phí cho người dùng. Không có các gói
                trả phí hoặc phí thuê bao định kỳ.
              </p>
              <p>
                <strong>Thay đổi chính sách:</strong> AIContent bảo lưu quyền
                thay đổi mô hình dịch vụ trong tương lai. Nếu có bất kỳ thay
                đổi nào, chúng tôi sẽ thông báo trước cho người dùng qua email
                hoặc thông báo trên hệ thống.
              </p>
              <p>
                <strong>Không có cam kết hoàn tiền:</strong> Vì Dịch vụ được
                cung cấp miễn phí, không áp dụng chính sách hoàn tiền. Tuy
                nhiên, chúng tôi cam kết cung cấp dịch vụ chất lượng và hỗ
                trợ khách hàng tốt nhất có thể.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              6. Quyền sở hữu trí tuệ
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Sở hữu của AIContent:</strong> Dịch vụ, bao gồm tất cả
                phần mềm, thiết kế, giao diện người dùng, API, công nghệ, cơ sở
                dữ liệu và nội dung liên quan (trừ Nội dung Người dùng) là tài
                sản của AIContent và được bảo vệ bởi luật sở hữu trí tuệ.
              </p>
              <p>
                <strong>Cấp phép sử dụng:</strong> AIContent cấp cho bạn quyền
                sử dụng cá nhân, không độc quyền, không thể chuyển nhượng, có
                thể thu hồi để sử dụng Dịch vụ theo các Điều khoản này.
              </p>
              <p>
                <strong>Nội dung do AI tạo ra:</strong> Đối với nội dung do AI
                tạo ra thông qua Dịch vụ của chúng tôi:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  Bạn sở hữu quyền sử dụng nội dung do AI tạo ra thông qua tài
                  khoản của bạn.
                </li>
                <li>
                  Bạn chịu trách nhiệm đảm bảo rằng việc sử dụng nội dung đó
                  không vi phạm quyền của bên thứ ba.
                </li>
              </ul>
              <p>
                <strong>Nội dung Người dùng:</strong> Bạn giữ quyền sở hữu đối
                với nội dung bạn tải lên hoặc tạo ra thông qua Dịch vụ. Bằng
                cách tải lên hoặc tạo nội dung, bạn cấp cho AIContent quyền sử
                dụng, sao chép, sửa đổi, tạo các tác phẩm phái sinh, phân phối
                và hiển thị nội dung đó cho mục đích cung cấp và cải thiện Dịch
                vụ.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              6. Giới hạn sử dụng dịch vụ
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>Khi sử dụng Dịch vụ, bạn đồng ý không:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Vi phạm bất kỳ luật hiện hành hoặc quy định nào.</li>
                <li>
                  Sử dụng Dịch vụ để tạo, đăng hoặc chia sẻ nội dung bất hợp
                  pháp, xâm phạm, lạm dụng, khiêu dâm, phỉ báng, hoặc gây hiểu
                  lầm.
                </li>
                <li>
                  Vi phạm quyền sở hữu trí tuệ hoặc quyền riêng tư của người
                  khác.
                </li>
                <li>
                  Phá vỡ, can thiệp, hoặc cố gắng phá vỡ hoạt động bình thường
                  của Dịch vụ.
                </li>
                <li>
                  Thực hiện kỹ thuật đảo ngược, giải mã, hoặc cố gắng truy cập
                  mã nguồn của Dịch vụ.
                </li>
                <li>
                  Sử dụng Dịch vụ một cách tự động mà không có sự cho phép trước
                  từ AIContent.
                </li>
                <li>
                  Bán lại, cho thuê, hoặc cấp phép lại Dịch vụ cho bất kỳ bên
                  thứ ba nào.
                </li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              7. Thay đổi và chấm dứt dịch vụ
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Thay đổi Dịch vụ:</strong> AIContent có quyền sửa đổi,
                tạm ngừng hoặc ngừng cung cấp bất kỳ phần nào của Dịch vụ vào
                bất kỳ lúc nào. Chúng tôi sẽ nỗ lực thông báo cho bạn về những
                thay đổi đáng kể.
              </p>
              <p>
                <strong>Thay đổi Điều khoản:</strong> Chúng tôi có thể cập nhật
                Điều khoản này theo thời gian. Nếu chúng tôi thực hiện thay đổi
                đáng kể, chúng tôi sẽ thông báo cho bạn thông qua email hoặc
                thông báo trong Dịch vụ ít nhất 30 ngày trước khi thay đổi có
                hiệu lực.
              </p>
              <p>
                <strong>Chấm dứt bởi Người dùng:</strong> Bạn có thể ngừng sử
                dụng Dịch vụ và hủy tài khoản của mình bất kỳ lúc nào.
              </p>
              <p>
                <strong>Chấm dứt bởi AIContent:</strong> Chúng tôi có thể tạm
                ngừng hoặc chấm dứt quyền truy cập của bạn vào Dịch vụ nếu bạn
                vi phạm Điều khoản này, nếu việc sử dụng của bạn có thể gây tổn
                hại hoặc trách nhiệm pháp lý cho AIContent hoặc người dùng khác,
                hoặc vì lý do kinh doanh hợp lý khác.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              8. Tuyên bố Miễn trừ Trách nhiệm về Nội dung AI
            </h2>
            <div className="text-gray-600 space-y-4 bg-yellow-100 border-l-4 border-yellow-500 p-4 rounded">
              <p className="font-semibold">Lưu ý quan trọng:</p>
              <p>
                Dịch vụ AIContent sử dụng công nghệ trí tuệ nhân tạo (AI) để hỗ
                trợ tạo nội dung. Công nghệ này đang trong quá trình phát triển
                và đôi khi có thể tạo ra nội dung không chính xác, không đầy đủ,
                gây hiểu lầm hoặc thậm chí phản cảm, không phản ánh quan điểm
                của AIContent.
              </p>
              <p>
                <strong>
                  Người dùng cần phải xem xét, đánh giá cẩn thận và chịu hoàn
                  toàn trách nhiệm
                </strong>{" "}
                đối với bất kỳ nội dung nào được tạo ra bởi Dịch vụ trước khi
                đăng tải, xuất bản hoặc sử dụng cho bất kỳ mục đích nào, đặc
                biệt là trên các nền tảng mạng xã hội, website hoặc các kênh
                truyền thông khác.
              </p>
              <p>
                <strong>
                  Không dựa vào Dịch vụ để được tư vấn chuyên môn:
                </strong>
                Nội dung do Dịch vụ tạo ra chỉ nhằm mục đích thông tin chung và
                tham khảo. Nó không thể thay thế cho lời khuyên từ các chuyên
                gia có trình độ trong các lĩnh vực như y tế, pháp lý, tài chính,
                v.v. Bất kỳ nội dung nào liên quan đến các chủ đề này đều không
                được coi là lời khuyên chuyên nghiệp, chẩn đoán hay phương pháp
                điều trị.
              </p>
              <p>
                AIContent không chịu trách nhiệm pháp lý cho bất kỳ hậu quả nào
                phát sinh từ việc người dùng tin tưởng, xuất bản hoặc sử dụng
                nội dung do Dịch vụ cung cấp mà không có sự kiểm duyệt và xác
                minh độc lập.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              9. Giới hạn trách nhiệm pháp lý
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Dịch vụ "nguyên trạng":</strong> Dịch vụ được cung cấp
                "nguyên trạng" và "như có sẵn" mà không có bất kỳ bảo đảm nào,
                rõ ràng hay ngụ ý. AIContent không bảo đảm rằng Dịch vụ sẽ không
                bị gián đoạn, kịp thời, an toàn, hoặc không có lỗi.
              </p>
              <p>
                <strong>Giới hạn thiệt hại:</strong> Trong phạm vi tối đa được
                pháp luật cho phép, AIContent sẽ không chịu trách nhiệm cho bất
                kỳ thiệt hại gián tiếp, ngẫu nhiên, đặc biệt, hậu quả hoặc mang
                tính trừng phạt nào, bao gồm nhưng không giới hạn ở mất lợi
                nhuận, mất dữ liệu hoặc mất cơ hội kinh doanh, phát sinh từ việc
                sử dụng hoặc không thể sử dụng Dịch vụ.
              </p>
              <p>
                <strong>Giới hạn trách nhiệm:</strong> Trong mọi trường hợp,
                tổng trách nhiệm pháp lý của AIContent đối với bất kỳ khiếu nại
                nào liên quan đến Dịch vụ sẽ không vượt quá số tiền bạn đã thanh
                toán cho Dịch vụ trong 12 tháng trước khi phát sinh khiếu nại.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              10. Quy trình giải quyết tranh chấp
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Thông báo về tranh chấp:</strong> Nếu bạn có khiếu nại
                hoặc tranh chấp liên quan đến Dịch vụ, vui lòng liên hệ với
                chúng tôi trước tiên để tìm cách giải quyết không chính thức.
              </p>
              <p>
                <strong>Hòa giải:</strong> Nếu không thể giải quyết tranh chấp
                thông qua thảo luận không chính thức, các bên đồng ý tham gia
                vào quá trình hòa giải không ràng buộc với một hòa giải viên
                trung lập được chấp nhận chung trước khi tiến hành các biện pháp
                pháp lý khác.
              </p>
              <p>
                <strong>Luật áp dụng:</strong> Điều khoản này sẽ được điều chỉnh
                và giải thích theo luật pháp Việt Nam, không bao gồm các quy
                định về xung đột pháp luật.
              </p>
              <p>
                <strong>Diễn đàn:</strong> Bất kỳ tranh chấp pháp lý nào phát
                sinh từ hoặc liên quan đến Điều khoản này hoặc Dịch vụ sẽ được
                giải quyết độc quyền bởi tòa án có thẩm quyền ở Việt Nam.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              11. Thông tin liên hệ
            </h2>
            <div className="text-gray-600">
              <p className="mb-4">
                Nếu bạn có bất kỳ câu hỏi hoặc thắc mắc nào về các Điều khoản
                này, vui lòng liên hệ với chúng tôi:
              </p>
              <ul className="space-y-2">
                <li>
                  <strong>Email:</strong> contact@youhomes.vn
                </li>
                <li>
                  <strong>Điện thoại:</strong> 0886399781
                </li>
                <li>
                  <strong>Địa chỉ:</strong> tòa Hồ Gươm Plaza, số 102 Trần Phú,
                  Hà Đông, Hà Nội
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsScreen;
